import React, { Component } from 'react';

import { trans } from '../../../../localization/index';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../components/Table/PageTable';
import { EnumPagingMode, EnumReportDishSortField } from '../../../../constants/enum';
import { getSortData } from '../../../../utils/sort';
import { sortReportDish } from './utils';

import TableEmpty from '../../../../components/Common/TableEmpty'


class ReportDishTable extends Component {
  state = {
    sort: null,
    sortOrder: null,
  };

  renderHeader = () => {
    const { sort, sortOrder } = this.state;

    const columns = [
      {
        id: 'number',
        label: trans('mod_report_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'items',
        label: trans('mod_report_header_dish'),
        width: '80%',
        sort: EnumReportDishSortField.DISH.id,
      },
      {
        id: 'quantity',
        label: trans('mod_report_header_quantity'),
        width: '15%',
        textAlign: 'center',
        sort: EnumReportDishSortField.QUANTITY.id,
      },
    ];

    return (
      <PageTableHeader
        columns={columns}
        onClick={this.onSort}
        sort={sort}
        sortOrder={sortOrder}
      />
    );
  };

  onSort = (newSort) => {
    const { sort: oldSort, sortOrder } = this.state;
    this.setState(getSortData(oldSort, newSort, sortOrder));
  };

  static renderRow(row, index) {
    const { id, name, dish_sum: dishSum } = row;
    return (
      <PageTableRow key={id}>
        <PageTableCell textAlign="center" className="">
          {index}
        </PageTableCell>
        <PageTableCell className="">{name}</PageTableCell>
        <PageTableCell textAlign="center">
          {dishSum}
        </PageTableCell>
      </PageTableRow>
    );
  }

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={20} noPadding>
          <TableEmpty txt="mod_report_table_not_find" />
        </PageTableCell>
      </PageTableRow>
    );
  }

  render() {
    const { sort, sortOrder } = this.state;
    const { table, getList, changePageSize, changeActivePage } = this.props;

    sortReportDish(table, sort, sortOrder);

    return (
      <PageTable
        paginationMode={EnumPagingMode.SELF_PAGING.id}
        table={table}
        renderHeader={this.renderHeader}
        renderRow={ReportDishTable.renderRow}
        renderEmpty={ReportDishTable.renderEmpty}
        getList={getList}
        changePageSize={changePageSize}
        changeActivePage={changeActivePage}
      />
    );
  }
}

export default ReportDishTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportDish/components/ReportDishTable.jsx